import React, { useEffect, useState } from 'react'

import { Paper, Box, useTheme, Typography } from '@material-ui/core'

import { usePropertyBilling } from '../../../hooks/usePropertyBilling'
import { Company } from '../../../../../../models'
import { InvoicePropertyDetails } from './InvoicePropertyDetails'
import { StripeFees } from './StripeFees'
import { useRent } from '../../../../../../hooks/useRent'

interface PropertyInvoicesProps {
    property: Company
}

export const Billing: React.FC<PropertyInvoicesProps> = ({ property }) => {
    const theme = useTheme()

    const { updateBillingConfig } = usePropertyBilling(property.id.toString())
    const {
        stripeConnectAccount,
        fetchStripeConnectAccount,
        updateStipeConnectAccount,
    } = useRent()
    useEffect(() => {
        fetchStripeConnectAccount()
    }, [])

    const [billableUnits, setBillableUnits] = useState(
        property.billable_unit_count,
    )
    const [ratePerUnit, setRatePerUnit] = useState(
        Number(property.billable_unit_rate),
    )
    const [rateInputValue, setRateInputValue] = useState('')

    const handleUpdateBilling = async (
        newBillableUnits: number,
        newRatePerUnit: number,
    ) => {
        try {
            await updateBillingConfig.mutateAsync({
                billable_unit_count: newBillableUnits,
                billable_unit_rate: newRatePerUnit,
            })

            // Update local state to reflect changes
            setBillableUnits(newBillableUnits)
            setRatePerUnit(newRatePerUnit)
            setRateInputValue(newRatePerUnit.toString())
        } catch (error) {
            console.error('Failed to update billing configuration:', error)
            throw error // Re-throw to let the dialog handle the error
        }
    }

    useEffect(() => {
        if (property?.id) {
            setBillableUnits(property.billable_unit_count || 0)
            setRatePerUnit(parseFloat(property.billable_unit_rate) || 0)
            setRateInputValue(
                (parseFloat(property.billable_unit_rate) || 0).toString(),
            )
        }
    }, [property?.id])

    const CONFIGURATION_SECTION_HEIGHT = 450

    return (
        <div style={{ padding: theme.spacing(2) }}>
            {/* Billing Configuration Section */}
            <Paper style={{ height: CONFIGURATION_SECTION_HEIGHT }}>
                <Box p={1}>
                    <InvoicePropertyDetails
                        name={property.name}
                        billableUnits={billableUnits}
                        ratePerUnit={ratePerUnit}
                        onUpdateBilling={handleUpdateBilling}
                    />
                </Box>
                <Box p={1}>
                    <StripeFees
                        stripeConnectAccount={stripeConnectAccount}
                        updateStipeConnectAccount={updateStipeConnectAccount}
                    />
                </Box>
            </Paper>
        </div>
    )
}
